export default __webpack_public_path__ + "static/media/OasisBackground.858ddd14.png";